import { includes as _includes } from 'lodash';
import { requestCredentials } from '@bringg/frontend-utils/dist/services/parent-window-communication';

class TokenService {
	private _token: string = '';
	private readonly isDev: boolean;

	constructor(envConfig) {
		this.isDev =
			envConfig.environment === 'development' ||
			_includes(envConfig.regions[envConfig.default_region].api_end_point, 'qa.bringg.com');
	}

	wasReferredFromBringg() {
		return (
			document.referrer?.includes('.bringg.com') ||
			document.referrer?.includes('.overvyoo.com') ||
			document.referrer?.includes('localhost')
		);
	}

	async tryFetchCredentials() {
		if (!window.opener || !this.wasReferredFromBringg()) {
			return;
		}

		try {
			const credentials = await requestCredentials({
				windowConsumer: window.opener,
				ignoreOrigin: this.isDev,
				waitTime: 3000
			});

			this.saveToken(credentials.token);
		} catch (error) {
			console.error(`failed to load credentials ${error.message}`, error);
		}
	}

	private saveToken = token => {
		this._token = token;
	};

	get token() {
		return this._token;
	}
}

export default TokenService;
